export const brandColors = {
  colors: {
    white: '#FFFFFF',
    black: '#000000',
    blue: {
      DEFAULT: '#0025F1',
      100: '#3554ff',
      200: '#798dff',
      300: '#bcc6ff',
      400: '#dde3ff',
      500: '#ebeeff',
      600: '#f8f9ff',
      700: '#FBFBFF',
    },
    orange: {
      DEFAULT: '#F19100',
      100: '#ffa318',
      200: '#ffb23f',
      300: '#ffc265',
      400: '#ffd18c',
      500: '#ffe0b2',
      600: '#FFF8EE',
      dark: '#794900',
    },
    red: {
      DEFAULT: '#F10000',
      dark: '#640606',
      100: '#ff3535',
      200: '#ff5757',
      300: '#ff7979',
      400: '#ff9a9a',
      500: '#ffbcbc',
      600: '#ffdddd',
      700: '#fff5f5',
    },
    green: {
      DEFAULT: '#39985C',
      light: '#e9f7ee',
      dark: '#1E5E35',
    },
    dark: {
      DEFAULT: '#000106',
      100: '#001279',
      200: '#001dc2',
    },
    gray: {
      DEFAULT: '#101322',
      100: '#101322',
      200: '#282B39',
      300: '#404351',
      400: '#5B5E6A',
      500: '#777985',
      600: '#9496A0',
      700: '#B3B4BC',
      800: '#D2D3D9',
      900: '#E2E3E7',
      1000: '#F4F4F6',
    },
    gatedOut: {
      DEFAULT: '#F1E700',
      100: '#FFF718',
      200: '#FFF93F',
      300: '#FFFA65',
      400: '#FFFB8C',
      500: '#FFFCB2',
      600: '#FFFED9',
    },
    import: {
      DEFAULT: '#00F1F1',
      100: '#18FFFF',
      200: '#3FFFFF',
      300: '#65FFFF',
      400: '#8CFFFF',
      500: '#B2FFFF',
      600: '#F0FFFF',
    },
    vessel: {
      DEFAULT: '#5C00F1',
      100: '#7118FF',
      200: '#893FFF',
      300: '#A065FF',
      400: '#B88CFF',
      500: '#D0B2FF',
      600: '#F2EBFF',
    },
    export: {
      DEFAULT: '#F100BC',
      100: '#FF18CD',
      200: '#FF3FD5',
      300: '#FF65DE',
      400: '#FF8CE6',
      500: '#FFB2EE',
      600: '#FFD9F7',
    },
    legacyBlue: '#1E334B',
  },
  boxShadow: {
    xs: '1px 2px 2px rgba(0, 0, 0, 0.14)',
    sm: '1px 2px 4px rgba(0, 0, 0, 0.11);',
    md: '4px 8px 16px rgba(0, 0, 0, 0.1);',
    lg: '4px 10px 20px rgba(0, 0, 0, 0.18), 1px 1px 4px rgba(0, 0, 0, 0.29);',
    xl: '16px 32px 64px rgba(0, 0, 0, 0.4);',
    b: '0px 2px 2px rgba(0, 0, 0, 0.11);',
    lt: '-2px -1px 2px rgba(0, 0, 0, 0.11)',
    inner: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)',
    none: 'none',
  },
  borderRadius: {
    none: '0',
    sm: '0.125rem',
    DEFAULT: '0.25rem',
    md: '0.375rem',
    lg: '0.5rem',
    full: '9999px',
    large: '12px',
  },
};
